<ng-container *ngIf="blocks && relatedData && relatedData.length && oggetto_view !== 'pagine'">
    <div class="container-sample-view d-flex flex-column align-items-center justify-content-center w-100"
        [ngClass]="{'bg-neutral-95': oggetto_view !== 'pagine' && oggetto_view !== 'persone' && oggetto_view !== 'docenti' && oggetto_view !== 'faq-procedure'}">
        <!-- TITOLI -->
        <div *ngIf="oggetto_view !== 'pagine'" class="container-title container d-flex justify-content-between align-items-center w-100">
            <div class="container-title__title" *ngIf="titlePage">
                <h2 class="ls-h2-section-title text-brand-10" [innerHTML]="titlePage"></h2>
            </div>
            <div class="container-title__button">
                <a *ngIf="!isLinkEsternal && blocks.link" [routerLink]="navigationService.splitUrlRouterLink(blocks.link.url).path" [queryParams]="navigationService.splitUrlRouterLink(blocks.link.url).queryParams">
                    <button class="btn-header-news ls-label-small-semibold text-uppercase" [innerHTML]="blocks.label_link"></button>
                </a>
                <a *ngIf="isLinkEsternal" target="_blank" [href]="[blocks.link.url]">
                    <button class="btn-header-news ls-label-small-semibold text-uppercase" [innerHTML]="blocks.label_link"></button>
                </a>
            </div>
        </div>
        <!-- END TITOLI -->
        <!-- PER VISTE CATEGORIA -->
        <div class="container-sample-view__content-category container" *ngIf="oggetto_view !== 'persone' && oggetto_view !== 'pagine'">
            <owl-carousel-o [options]="customOptionsOwl" class="position-relative no-print"
                [id]="'sample-view-carousel-' + oggetto_view">
                <ng-container *ngFor="let item of relatedData; let idx = index">
                    <ng-template carouselSlide let-owlItem>
                        <ng-container [ngSwitch]="oggetto_view">
                            <app-sample-news-small *ngSwitchCase="'news'" [isNews]="true" [dataNews]="item"></app-sample-news-small>
                            <app-sample-events-small *ngSwitchCase="'eventi'" [isEvent]="true" [block]="item"></app-sample-events-small>
                            <app-sample-card-avvisi *ngSwitchCase="'avvisi'" [isAvvisi]="true" [block]="item"></app-sample-card-avvisi>
                            <app-sample-card-faq *ngSwitchCase="'faq-procedure'" [isAvvisi]="true" [block]="item"></app-sample-card-faq>
                            <app-sample-card-docenti *ngSwitchCase="'docenti'" [isEvent]="true" [block]="item"></app-sample-card-docenti>
                        </ng-container>
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
            <div class="container-print">
                <ng-container *ngFor="let item of relatedData; let idx = index">
                    <ng-container [ngSwitch]="oggetto_view">
                        <app-sample-news-small *ngSwitchCase="'news'" [isNews]="true" [dataNews]="item"></app-sample-news-small>
                        <app-sample-events-small *ngSwitchCase="'eventi'" [isEvent]="true" [block]="item"></app-sample-events-small>
                        <app-sample-card-avvisi *ngSwitchCase="'avvisi'" [isAvvisi]="true" [block]="item"></app-sample-card-avvisi>
                        <app-sample-card-faq *ngSwitchCase="'faq-procedure'" [isAvvisi]="true" [block]="item"></app-sample-card-faq>
                        <app-sample-card-docenti *ngSwitchCase="'docenti'" [isEvent]="true" [block]="item"></app-sample-card-docenti>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <!-- END PER VISTE CATEGORIA -->
    </div>
</ng-container>
<ng-container *ngIf="blocks && relatedData && relatedData.length && oggetto_view === 'pagine'">
    <div class="d-flex flex-column align-items-center justify-content-center w-100">
        <!-- PAGINE CATEGORIA-->
        <!-- FLEX -->
        <ng-container *ngIf="blocks.visualizza_come_carousel === 'Off' && oggetto_view === 'pagine'">
            <div class="container-sample-view__content-flex d-flex flex-wrap container">
                <ng-container [ngSwitch]="oggetto_view">
                    <ng-container *ngFor="let item of relatedData; let idx = index">
                        <div class="col-12 col-sm-6 col-lg-3">
                            <app-sample-card-pagine *ngSwitchCase="'pagine'" [isEvent]="true" [block]="item"></app-sample-card-pagine>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
            <!-- CTA -->
            <div class="d-flex justify-content-center align-items-center p-5">
                <button *ngIf="viewMore" class="btn-header-news ls-label-small-semibold text-uppercase"
                    (click)="addContentResult()">{{"SEARCH_BAR.SHOW_MORE" | translate}}
                </button>
            </div>
            <!-- END CTA -->
        </ng-container>
        <!-- END FLEX -->
        <!-- CAROUSEL -->
        <ng-container *ngIf="blocks.visualizza_come_carousel === 'On' && oggetto_view === 'pagine'">
            <div class="container-sample-view__content-category container">
                <owl-carousel-o [options]="customOptionsOwl" class="position-relative no-print"
                    [id]="'sample-view-carousel-' + oggetto_view">
                    <ng-container *ngFor="let item of relatedData; let idx = index">
                        <ng-template carouselSlide let-owlItem>
                            <app-sample-card-pagine [isEvent]="true" [block]="item"></app-sample-card-pagine>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
                <div class="container-print">
                    <ng-container *ngFor="let item of relatedData; let idx = index">
                        <app-sample-card-pagine [isEvent]="true" [block]="item"></app-sample-card-pagine>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <!-- END CAROUSEL -->
        <!-- END PAGINE CATEGORIA-->
    </div>
</ng-container>